exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-wrapper-scroll-x[data-v-e29989de]{overflow-x:auto}.my-custom-scrollbar[data-v-e29989de]{max-height:500px;overflow-y:auto}.badge-success[data-v-e29989de]{background-color:#28a745!important}.badge-warning[data-v-e29989de]{background-color:#ffc107!important;color:#212529!important}.badge-info[data-v-e29989de]{background-color:#17a2b8!important}.badge-secondary[data-v-e29989de]{background-color:#6c757d!important}.text-wrap[data-v-e29989de]{word-wrap:break-word;white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e29989de","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/AssignmentSplitMergeSummary.vue
// module id = 1824
// module chunks = 0